<!-- @format -->

<duplication-page>
  <style>
    div.analysis-result {
      overflow: visible;
    }

    div.analysis-result > div.stickybox {
      position: sticky;
      top: 5px;
    }

    div.analysis-result > codemirror {
      position: sticky;
      top: 37px
    }
    div.locate-navigation_wrap {
      overflow: visible;
    }

    div.locate-navigation_wrap > div.locate-navigation-title_wrap {
      position: sticky;
      top: 0;
      background-color: #fff;
    }

  </style>
  <div class="wrapper page">
    <section class="page_wrap">
      <div class="page_inner">
        <nav class="breadcrumb">
          <ul class="breadcrumb_list">
            <li class="breadcrumb_list-item">
              <a href="{ routes.makePath('accept-page') }">解析結果一覧</a>
            </li>
            <li class="breadcrumb_list-item">
              <a
                href="{ routes.makePath('items-page', {analyticId: props.routeParams[0]}) }"
              >
                解析結果URL一覧
              </a>
            </li>
            <li class="breadcrumb_list-item">解析結果詳細</li>
          </ul>
          <!--/.breadcrumb_list-->
        </nav>
        <!--/.breadcrumb-->

        <h1 class="main_title page">解析結果詳細</h1>

        <section class="summary">
          <div class="summary_number-container duplication">
            <div
              class="summary_number-box level-{ getLevel(state.item.length, 'length') }"
            >
              <h2 class="summary_number-title">最高一致文字数</h2>
              <p class="summary_number">
                <emphasized-value
                  value="{ state.item.length }"
                ></emphasized-value>
              </p>
            </div>
            <!--/.summary_number-box-->
            <div
              class="summary_number-box level-{ getLevel(state.item.duplication_ratio*100, 'ratio') }"
            >
              <h2 class="summary_number-title">一致率</h2>
              <p class="summary_number">
                <emphasized-value
                  ratio="{ state.item.duplication_ratio }"
                ></emphasized-value>
              </p>
            </div>
            <!--/.summary_number-box-->
            <div
              class="summary_number-box locate level-{ getLevel(state.item.duplication_count, 'duplication') }"
            >
              <h2 class="summary_number-title">重複箇所</h2>
              <p class="summary_number">
                <emphasized-value
                  value="{ state.item.duplication_count }"
                  unit="箇所"
                ></emphasized-value>
              </p>
            </div>
            <!--/.summary_number-box-->
          </div>
          <!--/.summary_number-->
          <div class="summary_txt-container duplication">
            <div class="summary_txt-box">
              <h2 class="summary_txt-title">ページタイトル</h2>
              <p class="summary_txt">
                { state.item.title }
              </p>
            </div>
            <!--/.summary_txt-box-->
            <div class="summary_txt-box">
              <h2 class="summary_txt-title">URL</h2>
              <p class="summary_txt">
                <a
                  href="{ state.item.url }"
                  class="link_outer"
                  target="_blank"
                  referrerpolicy="no-referrer"
                  is="link-outer"
                >
                  { state.item.url }
                </a>
              </p>
            </div>
            <!--/.summary_txt-box-->
          </div>
          <!--/.summary_txt-->
        </section>
        <!--/.summary-->

        <section class="result">
		<p class="result-note"><strong>「重複箇所」エリアの「重複位置」</strong>をクリックすると該当箇所が反転します。</p>
		
          <div class="analysis-result-wrap">
            <div class="analysis-result">
              <div class="stickybox">
                <h2 class="analysis-result-title h2orig">解析元の文章</h2>
                <codemirror
                  height="{ state.cmh }"
                  value="{ state.origin }"
                  type="origin"
                  markers="{ state.duplications }"
                  marker="{ state.marker }"
                  readonly
                ></codemirror>
              </div>
            </div>
            <!--/.analysis-result-->
            <div class="analysis-result">
              <div class="stickybox">
                <h2 class="analysis-result-title h2tgt">検出されたURLの文章</h2>
                <codemirror
                  height="{ state.cmh }"
                  value="{ state.target }"
                  type="target"
                  markers="{ state.duplications }"
                  marker="{ state.marker }"
                  readonly
                ></codemirror>
              </div>
            </div>
            <!--/.analysis-result-->
          </div>
          <!--/.analysis-result-->
          <div class="locate-navigation_wrap">
            <div class="locate-navigation-title_wrap">
              <h2 class="locate-navigation-title">重複箇所</h2>
              <div class="locate-navigation-number">
                <emphasized-value
                  value="{ state.duplications.length }"
                  unit="箇所"
                ></emphasized-value>
              </div>
            </div>
            <!--/.locate-navigation-heading-->

            <div class="locate-navigation">
              <div class="locate-navigation-table">
                <div class="locate-navigation-thead">
                  <div class="blank"></div>
                  <div class="locate-navigation-heading">重複位置</div>
                  <div class="locate-navigation-heading">一致文字数</div>
                </div>
                <div class="locate-navigation-tbody">
                  <a
                    each="{ (duplication, i) in state.duplications }"
                    onclick="{ e => onDuplication(i) }"
                  >
                    <div class="locate-navigation-row">
                      <div class="icon"></div>
                      <div class="locate">
                        <div class="locate01">{ duplication.origin_line }</div>
                        <div class="arrow"></div>
                        <div class="locate02">{ duplication.target_line }</div>
                      </div>
                      <div class="number">
                        <span class="emphasis">{ duplication.length }</span>
                      </div>
                    </div>
                    <!--/.locate-navigation-row-->
                  </a>
                </div>
              </div>
              <!--locate-navigation-table-->
            </div>
            <!--/.locate-navigation-->
          </div>
          <!--/.locate-navigation_wrap-->
        </section>
        <!--/.result-->
      </div>
      <!--/.page_inner-->
    </section>
    <!--page_wrap-->
  </div>
  <!--/.wrapper-->

  <script>
    import di from "dependeny-injection";
    import pager from "@tags/parts/pager.riot";
    import tooltip from "@tags/parts/tooltip.riot";
    import codemirror from "@tags/parts/codemirror.riot";
    import gauge from "@tags/parts/gauge.riot";

    import { api as ResultsApi } from "@model/results.js";
    import { getLevel } from "@model/utils.js";
    import routes from "@model/routes.js";

    export default {
      components: { pager, tooltip, codemirror, gauge },
      getLevel,
      onBeforeMount() {
        this.routes = routes;
        this.state = {
          target: "",
          item: {},
          origin: "",
          target: "",
          duplications: [],
          marker: null,
          cmh: 300
        };
        window.addEventListener("resize", this.resizeBox.bind(this));
      },
      onBeforeUnmount() {
        window.removeEventListener("resize", this.resizeBox.bind(this));
      },
      async onMounted() {
        const analyticId = this.props.routeParams[0];
        const targetId = this.props.routeParams[1];
        di.loader.setState(true);
        const [a, b, c] = await Promise.all([
          ResultsApi.requestPageDetail(targetId),
          ResultsApi.requestContent(targetId, "duplication"),
          ResultsApi.requestDuplication(targetId),
        ]);
        if (a && a.success && b && b.success && c && c.success) {
          this.state.item = a.item;
          this.state.origin = b.origin;
          this.state.target = b.target;
          this.state.duplications = c.items;
        } else {
          di.toast.push(
            res && res.msg ? res.msg : "エラーが発生しました。",
            "negative"
          );
        }
        di.loader.setState(false);
        this.update();
        this.resizeBox();
      },
      onDuplication(i) {
        this.state.marker = this.state.duplications[i];
        this.update();
      },
      resizeBox() {
        const h2orig = this.$("h2.h2orig")
        const h2tgt = this.$("h2.h2tgt")
        const h2h = h2orig.clientHeight;
        const h2mb = parseInt(window.getComputedStyle(h2orig).getPropertyValue(`margin-bottom`));
        const maxHeight = window.innerHeight - h2h - h2mb - 50;
        this.state.cmh = maxHeight;
        h2orig.nextElementSibling.children[0].style.height = `${maxHeight}px`;
        h2tgt.nextElementSibling.children[0].style.height = `${maxHeight}px`;
      }
    };
  </script>
</duplication-page>
